export function slider() {

  //interviewHero_slide
  const interviewHero_slide = document.querySelector('.p-interviewHero_slide');
  if(interviewHero_slide) {
    const swiper = new Swiper(interviewHero_slide, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 5,
      speed: 20000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //reverseDirection: true, // 逆回転にするオプション
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          spaceBetween: 10,
        }
      },
      on: {
        resize: function () {
          this.update();
          if (this.autoplay) this.autoplay.start();
        }
      },
      
    });
  }

  //interviewLead_slide
  const interviewLead_slide = document.querySelector('.p-interviewLead_slide');
  if(interviewLead_slide) {
    const swiper = new Swiper(interviewLead_slide, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 5,
      speed: 8000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true, // 逆回転にするオプション
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          speed: 15000,
          spaceBetween: 10,
        }
      },
      on: {
        resize: function () {
          this.update();
          if (this.autoplay) this.autoplay.start();
        }
      }
    });
  }


  //indexIv_slide
  const indexIv_slide = document.querySelector('.p-indexIv_slide');
  if(indexIv_slide) {
    const swiper = new Swiper(indexIv_slide, {
      slidesPerView: 1.16,
      spaceBetween: 15,
      loop: true,
      pagination: {
        el: ".swiper-pagination--indexIv",
        clickable: true,
      },
      // 前後の矢印
      navigation: {
        nextEl: ".swiper-button-next--indexIv",
        prevEl: ".swiper-button-prev--indexIv",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        768: {
          slidesPerView: "auto",
          spaceBetween: 40,
        }
      },
    });
  }

  //loop
  const brand_slide = document.querySelector('.p-indexInfo_loopslide');
  if(brand_slide) {
    const swiper = new Swiper(brand_slide, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 5,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //reverseDirection: true, // 逆回転にするオプション
      },
      breakpoints: {
        768: {
          spaceBetween: 5,
        }
      },
    });
  }


  // const indexJobs_slide = document.querySelector('.p-indexJobs_list._slide');
  // if(indexJobs_slide) {
  //   const swiper = new Swiper(indexJobs_slide, {
  //     slidesPerView: 1.25,
  //     spaceBetween: 20,
  //     loop: true,
  //     centeredSlides: true,
  //   });
  // }


  //sp
  if (window.matchMedia('screen and (max-width:767px)').matches){ // SP

      
    }else{ // PC
  }


}